

























































































































import { Component, Vue } from 'vue-property-decorator'
import store from '../store'
import axios from 'axios'
import settingsCategoriesVue from './settingsCategories.vue'
import settingsGeneralVue from './settingsGeneral.vue'
import settingsNotificationsVue from './settingsNotifications.vue'
import settingsUsersVue from './settingsUsers.vue'

@Component({
  name: 'Settings',
  components: {
    general: settingsGeneralVue,
    categories: settingsCategoriesVue,
    notifications: settingsNotificationsVue,
    users: settingsUsersVue
  }
})
export default class extends Vue {
  created() {
    console.log('created')
  }
  navigate(to: string) {
    this.$router.push({ path: to })
  }

  async myfunction() {
    const answer = await axios.get(process.env.VUE_APP_BASE_URL + 'api/')
    console.log(answer)
  }
}
